'use client';;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:tillamook-com":true});}catch(e){}}();

import React from 'react';

import cx from 'clsx';
import PropTypes from 'prop-types';

import { BLOCKS } from '@contentful/rich-text-types';

import Button from 'components/ui/Button';
import ButtonCTA from 'components/ui/ButtonCTA';
import Img from 'components/ui/Img';
import RichText from 'components/ui/RichText';
import Text from 'components/ui/Text';

import styles from './PairingWheelOverlay.module.scss';

const headlineOverrides = {
    renderNode: {
        [BLOCKS.PARAGRAPH]: (node, children) => {
            return (
                <Text
                    as="p"
                    baseTheme="displayXSmall"
                    themes={{
                        large: 'displayMedium',
                        xLarge: 'displayLarge',
                    }}
                >
                    {children}
                </Text>
            );
        },
    },
};

const copyOverrides = {
    renderNode: {
        [BLOCKS.PARAGRAPH]: (node, children) => {
            return (
                <Text
                    as="p"
                    className={styles.paragraph}
                    baseTheme="bodyXSmall"
                    themes={{
                        large: 'bodyMedium',
                        xLarge: 'bodyLarge',
                    }}
                >
                    {children}
                </Text>
            );
        },
    },
};

const PairingWheelOverlay = ({
    headline,
    copy,
    image,
    viewGuideCta,
    pairAgainCtaText,
    isOpen,
    onClose,
    handlePairAgainClick,
    nextPairingWheelId,
}) => {
    return (
        <div
            className={cx(styles.root, {
                [styles.isOpen]: isOpen,
            })}
        >
            <div className={styles.content}>
                <div className={styles.headline}>
                    <RichText
                        richText={headline}
                        overrides={headlineOverrides}
                    />
                </div>
                <div className={styles.copy}>
                    <RichText richText={copy} overrides={copyOverrides} />
                </div>
                <div className={styles.buttons}>
                    <ButtonCTA
                        className={styles.cta}
                        {...viewGuideCta}
                        style="filled-blue-cream"
                        tabIndex={isOpen ? 0 : -1}
                        target="_blank"
                        rel="noopener noreferrer"
                        gta-label="pairing-wheel-guide"
                    />
                    {nextPairingWheelId && (
                        <Button
                            gtm-label="pair-again"
                            onClick={handlePairAgainClick}
                            className={styles.pairAgainButton}
                        >
                            <Text as="span" baseTheme="bodyMedium">
                                {pairAgainCtaText}
                            </Text>
                        </Button>
                    )}
                </div>
            </div>
            {image?.url && (
                <div className={styles.imageContainer}>
                    <Img
                        className={styles.image}
                        src={image.url}
                        width={image?.width}
                        height={image?.height}
                        alt={image.title || image.description || ''}
                        fallbackImageWidth={297 * 2}
                        customSources={[
                            {
                                breakpoint: 1024,
                                src: image.url,
                                imageWidth: 1024 * 1.5,
                            },
                            {
                                breakpoint: 768,
                                src: image.url,
                                imageWidth: 720 * 2,
                            },
                            {
                                src: image.url,
                                imageWidth: 297 * 2,
                            },
                        ]}
                    />
                </div>
            )}
            <Button
                onClick={onClose}
                className={styles.closeButton}
                gta-label="close-revealed-content"
            >
                <svg width="30" height="30" viewBox="0 0 30 30" fill="none">
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M15.062 14.1282L9.27949 8.3999L8.3995 9.27164L14.182 14.9999L8.39941 20.7283L9.27941 21.6001L15.062 15.8717L20.7194 21.476L21.5994 20.6043L15.942 14.9999L21.5994 9.39571L20.7194 8.52397L15.062 14.1282Z"
                        fill="currentColor"
                    />
                </svg>
                <span className="sr-only">Close Reveal Overlay</span>
            </Button>
        </div>
    );
};

PairingWheelOverlay.propTypes = {
    headline: PropTypes.object.isRequired,
    copy: PropTypes.object.isRequired,
    image: PropTypes.object,
    viewGuideCta: PropTypes.object,
    pairAgainCtaText: PropTypes.string,
    isOpen: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    handlePairAgainClick: PropTypes.func.isRequired,
};

export default PairingWheelOverlay;
